"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H3 = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const H3 = props => {
  return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    variant: "h3"
  }, props), props.children);
};
exports.H3 = H3;